import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { CommonService } from "src/app/core/services/common.service";
import { pdfDefaultOptions } from "ngx-extended-pdf-viewer";
import { DocumentDownloadDialogComponent } from "src/app/shared/components/document-download-dialog/document-download-dialog.component";
import { DocumentDownloadFalseDialogComponent } from "src/app/shared/components/document-download-false-dialog/document-download-false-dialog.component";
import { DocumentTemplateService } from "src/app/core/services/document-template.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-dialog-preview-pdf",
  templateUrl: "./dialog-preview-pdf.component.html",
})
export class DialogPreviewPdfComponent implements OnInit {
  public src: string;
  public language: string;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogPreviewPdfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { file: Blob; name: string, element?: {}, sync?: boolean },
    public sanitizer: DomSanitizer,
    public commonService: CommonService,
    private documentTemplateService: DocumentTemplateService,
    private router: Router
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
    // const blob = this.commonService.b64toBlob(this.data.file, 'application/pdf');
    // const blobUrl = URL.createObjectURL(blob);
    // this.src = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    this.language = localStorage.getItem("__language") || "vi";
  }

  ngOnInit() {
    this.showPdf();
  }

  showPdf() {
    const temp = this.blobToFile(this.data.file, "application/pdf");
    this.commonService.readFile(temp, (pdfSrc) => {
      this.src = pdfSrc;
    });
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  onNoClick() {
    this.dialogRef.close();
  }

  downloadTemplate() {
    if (!this.data.sync) {
      this.dialog.open(DocumentDownloadDialogComponent, {
        data: this.data.element,
      });
      return;
    }

    if (this.data.element)
      this.copyTemplate(this.data.element)
  }

  copyTemplate(data) {
    this.documentTemplateService
      .copyDocumentTemplate(data.id, 'SYNC')
      .subscribe((response) => {
        if (response.success) {
          this.documentTemplateService.typeforUpdateDocumentPage.next('create');
          const link = `/home-enterprise/document-template/update/${response.data.id}`;
          this.router.navigateByUrl(link).then(() => {
            this.dialog.closeAll();
          });
        }
        else {
          this.dialog.open(DocumentDownloadFalseDialogComponent, {
            data: {
              message: response.message,
              code: response.code,
              name: data.name
            },
          })
        }
      });
  }
}
